import React, { useMemo } from 'react';
import TableContainer from 'components/Common/TableContainer';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummyInventory = [
  {
    id: '1',
    quantityUnits: 800,
    batchNumber: 'B001',
    expiryDate: '2026-01-10',
  },
  {
    id: '2',
    quantityUnits: 400,
    batchNumber: 'B002',
    expiryDate: '2026-03-15',
  },
];

const InventoryTable = () => {
  const columns = useMemo(
    () => [
      {
        header: 'Batch',
        accessorKey: 'batchNumber',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Quantity (Units)',
        accessorKey: 'quantityUnits',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Expiry Date',
        accessorKey: 'expiryDate',
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    [],
  );

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Inventory</CardTitle>
        <TableContainer
          columns={columns}
          data={dummyInventory}
          isGlobalFilter={false}
          tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-borderless"
          theadClass="table-light"
          paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
          paginationClass="pagination"
        />
      </CardBody>
    </Card>
  );
};

export default InventoryTable;
